export const isParStockPurchase = (record) => [record?.source, record?.requisition_source, record?.requester_source].includes("par_stock");

export const parStockCoverageLabel = (language) => language === "es" ? "Cobertura de stock objetivo" : "Par stock coverage";
